import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './Patients.css';

function Subscriptions() {
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [featureList, setFeatureList] = useState([]);
    const [currentPlan, setCurrentPlan] = useState({
        id: null,
        name: '',
        price: '',
        max_admins: 1,
        max_doctors: 0,
        max_staff: 0,
        features: '',
        color: '#4e73df',
        price_includes_vat: 0,
        billing_cycle: 'monthly'
    });

    useEffect(() => {
        fetchPlans();
    }, []);

    const fetchPlans = () => {
        axios.get('./backend/get_plans.php')
            .then(res => {
                setPlans(Array.isArray(res.data) ? res.data : []);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        axios.post('./backend/save_plan.php', { ...currentPlan, features: featureList.join('\n') })
            .then(res => {
                toast.success(res.data.message);
                setShowModal(false);
                fetchPlans();
            })
            .catch(err => toast.error(err.response?.data?.message || 'İşlem başarısız.'));
    };

    const handleDelete = (id) => {
        if(window.confirm('Bu paketi silmek istediğinize emin misiniz?')) {
            axios.post('./backend/delete_plan.php', { id })
                .then(res => {
                    toast.success(res.data.message);
                    fetchPlans();
                })
                .catch(err => toast.error(err.response?.data?.message || 'Silme başarısız.'));
        }
    };

    const openModal = (plan = null) => {
        if (plan) {
            setCurrentPlan({
                ...plan,
                price_includes_vat: parseInt(plan.price_includes_vat || 0),
                color: plan.color || '#4e73df',
                billing_cycle: plan.billing_cycle || 'monthly'
            });
            setFeatureList(plan.features ? plan.features.split('\n') : []);
        } else {
            setCurrentPlan({
                id: null,
                name: '',
                price: '',
                max_admins: 1,
                max_doctors: 0,
                max_staff: 0,
                features: '',
                color: '#4e73df',
                price_includes_vat: 0,
                billing_cycle: 'monthly'
            });
            setFeatureList([]);
        }
        setShowModal(true);
    };

    const handleFeatureChange = (index, value) => {
        const newFeatures = [...featureList];
        newFeatures[index] = value;
        setFeatureList(newFeatures);
    };

    const addFeature = () => {
        setFeatureList([...featureList, '']);
    };

    const removeFeature = (index) => {
        const newFeatures = featureList.filter((_, i) => i !== index);
        setFeatureList(newFeatures);
    };

    if (loading) return <div>Yükleniyor...</div>;

    return (
        <div className="patients-container">
            <div className="header-actions">
                <h2>Abonelik Paketleri</h2>
                <button className="add-btn" onClick={() => openModal()}>+ Yeni Paket Ekle</button>
            </div>

            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center' }}>
                {plans.map(plan => (
                    <div key={plan.id} style={{
                        background: 'white',
                        borderRadius: '15px',
                        padding: '30px',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                        width: '300px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        borderTop: `5px solid ${plan.color || '#4e73df'}`,
                        position: 'relative'
                    }}>
                        <h3 style={{ margin: '0 0 10px 0', color: '#333', fontSize: '1.5rem' }}>{plan.name}</h3>
                        <div style={{ fontSize: '2rem', fontWeight: 'bold', color: plan.color || '#4e73df', marginBottom: '5px' }}>
                            {parseFloat(plan.price).toLocaleString('tr-TR')} ₺
                        </div>
                        <div style={{fontSize: '0.8rem', color: '#888', marginBottom: '20px'}}>
                            {parseInt(plan.price_includes_vat) ? 'KDV Dahil' : '+ KDV'} / {plan.billing_cycle === 'yearly' ? 'Yıl' : 'Ay'}
                        </div>
                        
                        <ul style={{ listStyle: 'none', padding: 0, width: '100%', marginBottom: '30px' }}>
                            <li style={{ padding: '10px 0', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between' }}>
                                <span>Yönetici (Admin)</span> <strong>{plan.max_admins === '-1' ? 'Sınırsız' : plan.max_admins}</strong>
                            </li>
                            <li style={{ padding: '10px 0', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between' }}>
                                <span>Doktor</span> <strong>{plan.max_doctors === '-1' ? 'Sınırsız' : plan.max_doctors}</strong>
                            </li>
                            <li style={{ padding: '10px 0', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between' }}>
                                <span>Personel</span> <strong>{plan.max_staff === '-1' ? 'Sınırsız' : plan.max_staff}</strong>
                            </li>
                            {plan.features && plan.features.split('\n').map((feature, idx) => (
                                <li key={idx} style={{ padding: '5px 0', fontSize: '0.9rem', color: '#555', display: 'flex', alignItems: 'center' }}>
                                    <span style={{color: '#1cc88a', marginRight: '5px'}}>✓</span> {feature}
                                </li>
                            ))}
                        </ul>
                        
                        <div style={{display: 'flex', gap: '10px', width: '100%'}}>
                            <button className="edit-btn" onClick={() => openModal(plan)} style={{flex: 1}}>Düzenle</button>
                            <button className="delete-btn" onClick={() => handleDelete(plan.id)} style={{flex: 1}}>Sil</button>
                        </div>
                    </div>
                ))}
            </div>

            {showModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <div className="modal-header">
                            <h3>{currentPlan.id ? 'Paketi Düzenle' : 'Yeni Paket Ekle'}</h3>
                            <button className="close-modal-btn" onClick={() => setShowModal(false)}>✕</button>
                        </div>
                        <div className="modal-body">
                            <form id="planForm" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label>Paket Adı</label>
                                    <input type="text" value={currentPlan.name} onChange={e => setCurrentPlan({...currentPlan, name: e.target.value})} required />
                                </div>
                                <div className="responsive-grid-2">
                                    <div className="form-group" style={{flex: 1}}>
                                        <label>Fiyat (TL)</label>
                                        <input type="number" step="0.01" value={currentPlan.price} onChange={e => setCurrentPlan({...currentPlan, price: e.target.value})} required />
                                    </div>
                                    <div className="form-group" style={{flex: 1}}>
                                        <label>Döngü</label>
                                        <select value={currentPlan.billing_cycle} onChange={e => setCurrentPlan({...currentPlan, billing_cycle: e.target.value})} style={{width: '100%', padding: '12px', borderRadius: '10px', border: '2px solid #eaecf4'}}>
                                            <option value="monthly">Aylık</option>
                                            <option value="yearly">Yıllık</option>
                                        </select>
                                    </div>
                                </div>
                                <div style={{display: 'flex', gap: '20px', marginBottom: '15px', alignItems: 'center'}}>
                                    <label style={{display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer'}}>
                                        <input type="checkbox" checked={currentPlan.price_includes_vat === 1} onChange={e => setCurrentPlan({...currentPlan, price_includes_vat: e.target.checked ? 1 : 0})} />
                                        KDV Dahil
                                    </label>
                                    <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                                        <label>Renk:</label>
                                        <input type="color" value={currentPlan.color} onChange={e => setCurrentPlan({...currentPlan, color: e.target.value})} style={{border: 'none', width: '40px', height: '30px', cursor: 'pointer'}} />
                                    </div>
                                </div>
                                <div className="responsive-grid-3">
                                    <div className="form-group">
                                        <label>Max Admin</label>
                                        <input type="number" value={currentPlan.max_admins} onChange={e => setCurrentPlan({...currentPlan, max_admins: e.target.value})} />
                                        <small style={{fontSize: '0.7rem', color: '#888'}}>-1 = Sınırsız</small>
                                    </div>
                                    <div className="form-group">
                                        <label>Max Doktor</label>
                                        <input type="number" value={currentPlan.max_doctors} onChange={e => setCurrentPlan({...currentPlan, max_doctors: e.target.value})} />
                                        <small style={{fontSize: '0.7rem', color: '#888'}}>-1 = Sınırsız</small>
                                    </div>
                                    <div className="form-group">
                                        <label>Max Personel</label>
                                        <input type="number" value={currentPlan.max_staff} onChange={e => setCurrentPlan({...currentPlan, max_staff: e.target.value})} />
                                        <small style={{fontSize: '0.7rem', color: '#888'}}>-1 = Sınırsız</small>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Özellikler (Maddeler)</label>
                                    {featureList.map((feature, index) => (
                                        <div key={index} style={{display: 'flex', gap: '5px', marginBottom: '5px'}}>
                                            <input type="text" value={feature} onChange={e => handleFeatureChange(index, e.target.value)} placeholder="Özellik girin..." style={{flex: 1}} />
                                            <button type="button" onClick={() => removeFeature(index)} style={{background: '#e74a3b', color: 'white', border: 'none', borderRadius: '5px', width: '30px', cursor: 'pointer'}}>✕</button>
                                        </div>
                                    ))}
                                    <button type="button" onClick={addFeature} style={{background: '#36b9cc', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '5px', cursor: 'pointer', fontSize: '0.8rem'}}>
                                        + Özellik Ekle
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div className="modal-actions">
                            <button type="button" className="cancel-btn" onClick={() => setShowModal(false)}>İptal</button>
                            <button type="submit" form="planForm" className="save-btn">Kaydet</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Subscriptions;